import { Injectable } from '@angular/core';

import { cercaStorage } from "./data.service";

@Injectable()
export class CercaService {

    constructor(
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(cercaStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(cercaStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(cercaStorage + "-new");
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/shared/cerca.service.ts
 **/